import { useLogoutMutation } from './queries/login'

export const useLogout = () => {
  const { mutate } = useLogoutMutation()

  return {
    logout: () =>
      mutate(undefined, {
        onSuccess() {
          window.location.replace('/')
        },
      }),
  }
}
